
import SignIn from './signin.mjs';
import SignUp from './signup.mjs';

export default class FlyAuthUI {
  static SignIn = SignIn
  static SignUp = SignUp
}
